import { dynamicBlockType } from '../constants';

export class DynamicBlockModel {
  constructor(item = {}) {
    this.type = item.type || dynamicBlockType.CONTENT_BLOCK;
    this.properties = item.properties || {};
  }
}
